<template>
  <v-container fluid>
    <v-form class="pt-5">
      <v-row>
        <v-col cols="12">
          <informacoes-basicas id="informacoes-basicas-rel" :nomeCanvas.sync="canvas.nome" />
        </v-col>
      </v-row>
      <v-row id="row-parametros">
        <v-col md="6" cols="12">
          <base-material-card
            color="primary"
            icon="mdi-map-marker-plus-outline"
            inline
            class="px-5 py-3"
            style="min-height: 600px"
            title="Layers Personalizados"
          >
            <v-row>
              <v-col cols="12">
                <select-layers-table id="selecionar-layers" />
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
        <v-col md="6" cols="12">
          <base-material-card
            color="primary"
            icon="mdi-map-outline"
            inline
            class="px-5 py-3"
            style="min-height: 600px"
            title="Visualização do mapa"
          >
            <v-row>
              <v-col cols="12">
                <preview-mapa id="visualizar-mapa" />
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row id="row-btn-save">
        <v-col cols="12">
          <v-btn
            id="btn-save"
            color="primary"
            min-width="100"
            style="float: right"
            class="mr-0 mt-n5"
            :disabled="btnSaveDisabled"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import CanvasService from '@/services/CanvasService';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      InformacoesBasicas: () => import('@/components/canvas/InformacoesBasicas'),
      SelectLayersTable: () => import('@/components/canvas/SelectLayersTable'),
      PreviewMapa: () => import('@/components/canvas/PreviewMapa')
    },

    data: () => ({
      canvas: {
        nome: ''
      },
      loading: false
    }),

    computed: {
      layers() {
        return this.$store.getters.getCanvasConfigLayers;
      },

      layersIds() {
        return this.layers.map((layer) => layer.id);
      },

      opacidades() {
        return this.layers.map((layer) => layer.opacidade);
      },

      btnSaveDisabled() {
        return !(this.canvas.nome && this.layers.length);
      }
    },

    mounted() {
      this.$store.dispatch('resetaCanvasConfig');

      if (this.$route.params.id) {
        this.getMapa(this.$route.params.id);
      }
    },

    methods: {
      getMapa(id) {
        CanvasService.getCanvasById(id)
          .then((response) => {
            this.canvas = response.data.data;
            this.$store.dispatch('setCanvasConfigLayers', this.canvas.layers);
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar o mapa.', '', {
              position: 'topRight'
            })
          );
      },

      salvar() {
        this.loading = true;

        let data = {
          id: this.$route.params.id ? this.$route.params.id : null,
          nome: this.canvas.nome,
          config: {
            layers: this.layersIds,
            opacidades: this.opacidades
          }
        };

        CanvasService.save(data)
          .then(() => {
            this.$toast.success('Mapa salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['CANVAS_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar o mapa.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
